// REACT IMPORTS
import React, { useEffect } from "react";

// ICON IMPORTS
import DcdialLogo from "icons/DCDialLogo";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { useParams } from "react-router-dom";
import { paymentLogoGet } from "store/slices/paymentsSlice";
import logo from "icons/smallLogo.svg";
import Skeleton from "react-loading-skeleton";
import { decode } from "utils/HelperFunctions";
import { RootState } from "store/store";
import { useTid } from "utils/testid";

/* ----------<img src={DCDialLogo1} alt="" />--------------------------- LOGIN SIDE PANEL ------------------------------------- */

const SidePanel = () => {
  const tid = useTid();
  const {
    companyDetails,
    paymentLogo,
    isCompanyDetailsLoading,
    isLogoLoading,
  } = useAppSelector((state: RootState) => state.payment);
  const { brandColor, isDark } = useAppSelector(
    (state: RootState) => state.dashboard
  );
  const { clusterId: cluster_id } = useParams();
  const clusterId = decode(cluster_id || "", true);
  const dispatch = useAppDispatch();

  const onGetLogo = async () => {
    try {
      let payload = {
        cluster_id: clusterId,
      };
      await dispatch(paymentLogoGet(payload)).unwrap();
    } catch (error: any) {
      console.log("get logo err: -->", error?.message);
    }
  };
  useEffect(() => {
    if (clusterId) onGetLogo();
  }, [clusterId]);

  return (
    <div
      style={{ backgroundColor: brandColor }}
      className={`bg-[${brandColor}] lg:h-[var(--shell-vh)] h-fit xl:px-14 lg:px-[50px] px-4 lg:pt-10 pt-[14px] pb-5 flex flex-col justify-between animate__animated animate__fadeIn`}
      data-testid={tid("auth-side-panel")}
      aria-label="Authentication brand panel"
    >
      <div>
        <div className="lg:w-fit w-36 flex items-center gap-[10px]">
          {isLogoLoading ? (
            <div className="h-10 lg:h-10 flex">
              <Skeleton height={40} width={120} />
            </div>
          ) : (
            <>
              {paymentLogo ? (
                <div className="h-16 lg:h-16 flex">
                  <img
                    src={paymentLogo}
                    alt="Company logo"
                    className="animate__animated animate__fadeIn object-contain"
                  />
                </div>
              ) : (
                <img
                  src={logo}
                  alt="DCDial logo"
                  className="animate__animated animate__fadeIn"
                />
              )}
              {!paymentLogo && (
                <div className="text-purple font-medium text-xl leading-[30px]">
                  CompanyName
                </div>
              )}
            </>
          )}
        </div>
        <div className="lg:pt-[45px] pt-4">
          <p
            className={`max-w-[381px] lg:text-3xl text-base leading-[24px] lg:leading-[55px] font-medium ${
              isDark ? "!text-darktxtParagraph" : "!text-txtParagraph"
            }`}
          >
            {isCompanyDetailsLoading ? (
              <Skeleton height={32} width={100} />
            ) : (
              companyDetails?.name ||
              companyDetails?.company_name ||
              "Company Name"
            )}{" "}
            partners with DCDial for simplified billing.
          </p>
        </div>
      </div>
      <div className="hidden items-center lg:flex flex-wrap">
        <div
          className={`flex items-center gap-2 text-xs lg:text-base font-normal leading-normal ${
            isDark ? "!text-darktxtParagraph" : "!text-txtParagraph"
          }`}
        >
          Powered by
          <DcdialLogo aria-hidden="true" />
        </div>
        <div className="h-5 w-[1px] bg-strokePrimary mx-4" />
        <div className="flex lg:gap-5 gap-3 items-center">
          <a
            target="_blank"
            rel="noreferrer"
            href={"https://www.dcdial.com/legal/terms-of-service"}
            className={`text-xs lg:text-base  font-normal leading-normal hover:!text-blue hover:!underline cursor-pointer ${
              isDark ? "!text-darktxtParagraph" : "!text-txtParagraph"
            }`}
            data-testid={tid("side-panel-terms-link")}
            aria-label="Terms of service"
          >
            Terms
          </a>
          <a
            target="_blank"
            rel="noreferrer"
            href={"https://www.dcdial.com/legal/privacy-policy"}
            className={`text-xs lg:text-base font-normal leading-normal hover:!text-blue hover:!underline cursor-pointer ${
              isDark ? "!text-darktxtParagraph" : "!text-txtParagraph"
            }`}
            data-testid={tid("side-panel-privacy-link")}
            aria-label="Privacy policy"
          >
            Privacy
          </a>
        </div>
      </div>
    </div>
  );
};

export default SidePanel;
